<template>
  <el-dialog
    title="询价"
    :visible.sync="dialogVisible"
    width="840"
    :before-close="handleClose"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="flex">
        <el-form-item label="联系人" prop="name">
          <el-input v-model="ruleForm.name" :style="`width: ${widthInput}px`"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="ruleForm.phone" :style="`width: ${widthInput}px`"></el-input>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="企业名称" prop="companyName">
          <el-input v-model="ruleForm.companyName" :style="`width: ${widthInput}px`"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input v-model="ruleForm.address" :style="`width: ${widthInput}px`"></el-input>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="需求数量" prop="orderNum">
          <el-input-number v-model="ruleForm.orderNum" :min="1" :style="`width: ${widthInput}px`"></el-input-number>
        </el-form-item>
        <el-form-item label="交付日期" prop="deliveryDate">
          <el-date-picker
              :style="`width: ${widthInput}px`"
              v-model="ruleForm.deliveryDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="请选择交付日期">
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="订货方式" prop="orderingMethodUuid">
          <el-select v-model="ruleForm.orderingMethodUuid" :style="`width: ${widthInput}px`" clearable placeholder="请选择订货方式">
            <el-option
                v-for="item in orderingMethods"
                :key="item.uuid"
                :label="item.name"
                :value="item.uuid"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="备注" prop="bz" style="width:100%">
          <el-input type="textarea" :rows="3" v-model="ruleForm.remark" placeholder="备注" style="width:100%"></el-input>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item  style="width:100%">
        <el-upload
            class="avatar-uploader"
            action="/service-center/upload/file/single"
            :file-list="fileList"
            :limit="5"
            accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
            :on-remove="handleRemoveFile"
            :on-error="handleFileError"
            :on-success="handleFileSuccess">
          <el-button size="small" type="primary">上传附件</el-button>
        </el-upload>
        <span class="red" v-if="fileList.length == 0">
                            *未选择任何文件 注意：单个附件大小不能超过2M
                        </span>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {addProductConsult} from "../../../utils/product";
import {getDictionaryItem} from "../../../utils/interface";

export default {
  data() {
    return {
      dialogVisible: false,
      widthInput: 300,
      orderingMethods: [],
      fileList: [],
      ruleForm: {
        productSpecUuid: "",
        name: "",
        phone: "",
        companyName: "",
        address: "",
        orderNum: "",
        deliveryDate:"",
        orderingMethodUuid:"",
        orderingMethodName:"",
        remark:"",
        productOrderFileList:[],
      },
      rules: {
        name: [{ required: true, message: "请填写联系人名称", trigger: "blur" }],
        phone: [{ required: true, message: "请填写联系电话", trigger: "blur" }],
        address: [{ required: true, message: "请填写联系地址", trigger: "blur" }],
        orderNum: [{ required: true, message: "请填写需求数量", trigger: "blur" }],
        deliveryDate: [{ required: true, message: "请填写交付日期", trigger: "blur" }],
        orderingMethodUuid: [{ required: true, message: "请选择订货方式", trigger: "change" }],
      },
    };
  },
  methods: {
    init(productSpecUuid) {
      this.handleClose();
      this.ruleForm.productSpecUuid = productSpecUuid;
      this.ruleForm.name=this.$store.state.isUsermessage.name;
      this.ruleForm.phone=this.$store.state.isUsermessage.tel;
      this.dialogVisible = true;

      getDictionaryItem({
        groupCode: 'ORDERING_METHOD'
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.orderingMethods = res
        }
      });
    },
    handleClose() {
      this.ruleForm={
        productSpecUuid: "",
        name: "",
        phone: "",
        companyName: "",
        address: "",
        orderNum: "",
        deliveryDate:"",
        orderingMethodUuid:"",
        orderingMethodName:"",
        remark:"",
        productOrderFileList:[],
      }
      this.dialogVisible = false;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.orderingMethods.forEach(items => {
            if (items.uuid == this.ruleForm.orderingMethodUuid) {
              this.ruleForm.orderingMethodName = items.name;
            }
          })
          if(this.fileList && this.fileList.length > 0){
            this.ruleForm.productOrderFileList = [];
            this.fileList.forEach(items => {
                this.ruleForm.productOrderFileList.push({
                  url: items.url,
                  name: items.name,
                });
            })
          }
          this.handleSubmitForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSubmitForm(){
      addProductConsult(this.ruleForm).then(res=>{
        if(res.success){
          this.$message.success("询价提交成功");
          this.handleClose();
        }else{
          this.$message.error(res.message);
        }
      });
    },
    // 模板附件
    handleFileSuccess(res, file) {
      this.fileList.push(res);
    },
    handleRemoveFile(file, fileList) {
      this.fileList = fileList;
    },

    handleFileError(err, file, fileList) {
      this.$message.error(err);
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.consultingBottom {
  margin-top: 25px;
  align-items: center;

  button {
    border: none;
    background: #099;
    border-radius: 4px;
    margin-left: 15px;
    padding: 6px 18px;
    color: #fff;
  }

  p {
    width: 75px;
    text-align: right;
  }

  p:nth-last-child(1) {
    font-size: 12px;
    color: #d60000;
    margin-left: 10px;
  }
}
.red {
  color: #d60000;
  margin-left: 10px;
}
/deep/.el-dialog {
  width: 840px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/product/components/inquiry.vue